import React from "react";
const IconYoutube = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <g fill="currentColor" clipPath="url(#a)">
      <path d="m8.466 8.054 3.92 2.23-3.92 2.23v-4.46Z" />
      <path
        fillRule="evenodd"
        d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm16.641 3.92a1.886 1.886 0 0 0-1.326-1.335C14.688 5 10 5 10 5s-4.688 0-5.86.315A1.885 1.885 0 0 0 2.814 6.65C2.5 7.828 2.5 10.284 2.5 10.284s0 2.456.314 3.634a1.886 1.886 0 0 0 1.326 1.335c1.173.315 5.86.315 5.86.315s4.688 0 5.86-.315a1.885 1.885 0 0 0 1.326-1.335c.314-1.178.314-3.634.314-3.634s0-2.456-.314-3.634Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IconYoutube;
